var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularFaculty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27V15C29 14.4696 28.7893 13.9609 28.4142 13.5858C28.0391 13.2107 27.5304 13 27 13H14",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 31H30C30.5304 31 31.0391 30.7893 31.4142 30.4142C31.7893 30.0391 32 29.5304 32 29V28C32 27.7348 31.8946 27.4804 31.7071 27.2929C31.5196 27.1054 31.2652 27 31 27H21C20.7348 27 20.4804 27.1054 20.2929 27.2929C20.1054 27.4804 20 27.7348 20 28V29C20 29.5304 19.7893 30.0391 19.4142 30.4142C19.0391 30.7893 18.5304 31 18 31ZM18 31C17.4696 31 16.9609 30.7893 16.5858 30.4142C16.2107 30.0391 16 29.5304 16 29V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13C13.4696 13 12.9609 13.2107 12.5858 13.5858C12.2107 13.9609 12 14.4696 12 15V17C12 17.2652 12.1054 17.5196 12.2929 17.7071C12.4804 17.8946 12.7348 18 13 18H16",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularFaculty);
export default __webpack_public_path__ + "static/media/RegularFaculty.edc3d4e82fb667640c3411c2b8cef225.svg";
export { ForwardRef as ReactComponent };